import InsightsTooltip from 'components/ReusableComponents/Charts/Inslghts/InsightsTooltip'
import CloseIcon from 'components/ReusableComponents/CloseIcon'
import Dialog from 'components/ReusableComponents/Dialog'
import SmartDatepicker from 'components/ReusableComponents/SmartDatepicker'
import { barColors } from 'features/Engagement/engagementConstants'
import TripAdvisorIcon from 'features/Engagement/TripAdvisorRating/TripAdvisorIcon'
import moment from 'moment'
import { useState } from 'react'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

import styles from './TripAdvisorRatingDialog.module.scss'

const data = {
  '2021-06-05T12:16:03.578Z': {
    rating: 4,
    reviews: 220,
    rankingInArea: 4
  },
  '2021-06-06T12:16:03.578Z': {
    rating: 5,
    reviews: 230,
    rankingInArea: 5
  },
  '2021-06-07T12:16:03.578Z': {
    rating: 4,
    reviews: 240,
    rankingInArea: 3
  },
  '2021-06-08T12:16:03.578Z': {
    rating: 3,
    reviews: 245,
    rankingInArea: 5
  },
  '2021-06-09T12:16:03.578Z': {
    rating: 3,
    reviews: 248,
    rankingInArea: 3
  },
  '2021-06-10T12:16:03.578Z': {
    rating: 3,
    reviews: 250,
    rankingInArea: 2
  },
  '2021-06-11T12:16:03.578Z': {
    rating: 5,
    reviews: 259,
    rankingInArea: 4
  },
  '2021-06-12T12:16:03.578Z': {
    rating: 4,
    reviews: 260,
    rankingInArea: 1
  },
  '2021-06-13T12:16:03.578Z': {
    rating: 5,
    reviews: 264,
    rankingInArea: 3
  },
  '2021-06-14T12:16:03.578Z': {
    rating: 4,
    reviews: 267,
    rankingInArea: 2
  },
  '2021-06-15T12:16:03.578Z': {
    rating: 5,
    reviews: 270,
    rankingInArea: 3
  },
  '2021-06-16T12:16:03.578Z': {
    rating: 4,
    reviews: 277,
    rankingInArea: 1
  },
  '2021-06-17T12:16:03.578Z': {
    rating: 4,
    reviews: 281,
    rankingInArea: 5
  },
  '2021-06-18T12:16:03.578Z': {
    rating: 5,
    reviews: 288,
    rankingInArea: 5
  },
  '2021-06-19T12:16:03.578Z': {
    rating: 3,
    reviews: 215,
    rankingInArea: 5
  },
  '2021-06-20T12:16:03.578Z': {
    rating: 4,
    reviews: 220,
    rankingInArea: 5
  },
  '2021-06-21T12:16:03.578Z': {
    rating: 3,
    reviews: 200,
    rankingInArea: 4
  },
  '2021-06-22T12:16:03.578Z': {
    rating: 5,
    reviews: 242,
    rankingInArea: 1
  },
  '2021-06-23T12:16:03.578Z': {
    rating: 5,
    reviews: 240,
    rankingInArea: 3
  },
  '2021-06-24T12:16:03.578Z': {
    rating: 4,
    reviews: 214,
    rankingInArea: 3
  },
  '2021-06-25T12:16:03.578Z': {
    rating: 4,
    reviews: 211,
    rankingInArea: 3
  },
  '2021-06-26T12:16:03.578Z': {
    rating: 5,
    reviews: 235,
    rankingInArea: 2
  },
  '2021-06-27T12:16:03.578Z': {
    rating: 4,
    reviews: 244,
    rankingInArea: 5
  },
  '2021-06-28T12:16:03.578Z': {
    rating: 4,
    reviews: 223,
    rankingInArea: 3
  },
  '2021-06-29T12:16:03.578Z': {
    rating: 5,
    reviews: 228,
    rankingInArea: 5
  },
  '2021-06-30T12:16:03.578Z': {
    rating: 4,
    reviews: 228,
    rankingInArea: 2
  }
}

const chartData = Object.keys(data).map(k => ({
  name: moment(k).format('MMM D'),
  ...data[k]
}))

const TripAdvisorRatingDialog = ({ onCloseClick }) => {
  const [startDate, setStartDate] = useState(moment().subtract('7', 'days'))
  const [endDate, setEndDate] = useState(moment())

  return (
    <Dialog>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h2 className={styles.dialogTitle}>
            <TripAdvisorIcon width={34} height={34} style={{ marginRight: 10 }} />{' '}
            TripAdvisor details
          </h2>
          <SmartDatepicker
            startDate={startDate}
            endDate={endDate}
            onChangeStartDate={setStartDate}
            onChangeEndDate={setEndDate}
          />
          <button onClick={onCloseClick} className={styles.closeButton}>
            <CloseIcon />
          </button>
        </div>
        <div className={styles.graphsHolder}>
          <div className={styles.graphHolder}>
            <p className={styles.chartLabel}>Rating</p>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                width="100%"
                height={250}
                data={chartData}
                margin={{
                  top: 0,
                  right: 0,
                  left: 0,
                  bottom: 15
                }}
              >
                <CartesianGrid stroke="#F2F2F2" vertical={false} />
                <XAxis
                  dataKey="name"
                  axisLine={{ stroke: '#F2F2F2', strokeWidth: 1 }}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(0, 14)'
                  }}
                  tickSize={0}
                  padding={{ top: 30, bottom: 20, right: 40 }}
                />
                <YAxis
                  tickSize={0}
                  axisLine={false}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(-10, 0)'
                  }}
                  domain={['dataMin', 'dataMax']}
                  padding={{ top: 40, bottom: 0 }}
                />
                <Tooltip
                  content={<InsightsTooltip fontSize={15} />}
                  cursor={{
                    stroke: 'red',
                    strokeWidth: 0,
                    fill: '#dedede',
                    opacity: 0.22
                  }}
                />
                <Line
                  type="monotone"
                  dataKey="rating"
                  //stroke={colors[i]}
                  stroke="#66BB6A"
                  activeDot={{ r: 8 }}
                  strokeWidth={3}
                  dot={false}
                  isUpdateAnimationActive={false}
                  isAnimationActive={false}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
          <div className={styles.graphHolder}>
            <p className={styles.chartLabel}>Reviews</p>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                width="100%"
                height={250}
                data={chartData}
                margin={{
                  top: 0,
                  right: 0,
                  left: 0,
                  bottom: 15
                }}
              >
                <CartesianGrid stroke="#F2F2F2" vertical={false} />
                <XAxis
                  dataKey="name"
                  axisLine={{ stroke: '#F2F2F2', strokeWidth: 1 }}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(0, 14)'
                  }}
                  tickSize={0}
                  padding={{ top: 30, bottom: 20, right: 40 }}
                />
                <YAxis
                  tickSize={0}
                  axisLine={false}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(-10, 0)'
                  }}
                  //domain={['dataMin', 'dataMax']}
                  padding={{ top: 40, bottom: 0 }}
                />
                <Tooltip
                  content={<InsightsTooltip fontSize={15} />}
                  cursor={{
                    stroke: 'red',
                    strokeWidth: 0,
                    fill: '#dedede',
                    opacity: 0.22
                  }}
                />
                <Bar dataKey="reviews" fill={barColors[0]} barSize={8} />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className={styles.graphHolder}>
            <p className={styles.chartLabel}>Ranking in area</p>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                width="100%"
                height={250}
                data={chartData}
                margin={{
                  top: 0,
                  right: 0,
                  left: 0,
                  bottom: 15
                }}
              >
                <CartesianGrid stroke="#F2F2F2" vertical={false} />
                <XAxis
                  dataKey="name"
                  axisLine={{ stroke: '#F2F2F2', strokeWidth: 1 }}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(0, 14)'
                  }}
                  tickSize={0}
                  padding={{ top: 30, bottom: 20, right: 40 }}
                />
                <YAxis
                  tickSize={0}
                  axisLine={false}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(-10, 0)'
                  }}
                  domain={['dataMin', 'dataMax']}
                  padding={{ top: 40, bottom: 0 }}
                  reversed
                />
                <Tooltip
                  content={<InsightsTooltip fontSize={15} />}
                  cursor={{
                    stroke: 'red',
                    strokeWidth: 0,
                    fill: '#dedede',
                    opacity: 0.22
                  }}
                />
                <Line
                  type="monotone"
                  dataKey="rankingInArea"
                  stroke="#FEC213"
                  activeDot={{ r: 8 }}
                  strokeWidth={3}
                  dot={false}
                  isUpdateAnimationActive={false}
                  isAnimationActive={false}
                  name="ranking in area"
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default TripAdvisorRatingDialog
